<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="filters.tranDate_from"
                            :label="labels.tranDate_from"
                            :error-messages="errors.collect('tranDate_from')"
                            data-vv-name="tranDate_from"
                            :data-vv-as="labels.tranDate_from"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            v-model="filters.tranDate_to"
                            :label="labels.tranDate_to"
                            :error-messages="errors.collect('tranDate_to')"
                            data-vv-name="tranDate_to"
                            :data-vv-as="labels.tranDate_to"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-expansion-panels v-model="toogleMoreFilter" multiple>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <div><v-icon>mdi-filter-variant</v-icon> Show More Filters</div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card>
                              <v-card-text>
                                <v-container fluid grid-list-lg>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm6 md6 lg6 xl6>
                                      <v-text-field
                                        :label="labels.origVehRegNo"
                                        v-model="filters.origVehRegNo"
                                        :error-messages="errors.collect('origVehRegNo')"
                                        data-vv-name="origVehRegNo"
                                        :data-vv-as="labels.origVehRegNo"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 xl6>
                                      <v-text-field
                                        :label="labels.newVehRegNo"
                                        v-model="filters.newVehRegNo"
                                        :error-messages="errors.collect('newVehRegNo')"
                                        data-vv-name="newVehRegNo"
                                        :data-vv-as="labels.newVehRegNo"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 xl6>
                                      <v-text-field
                                        :label="labels.origChasNo"
                                        v-model="filters.origChasNo"
                                        :error-messages="errors.collect('origChasNo')"
                                        data-vv-name="origChasNo"
                                        :data-vv-as="labels.origChasNo"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 xl6>
                                      <v-text-field
                                        :label="labels.newChasNo"
                                        v-model="filters.newChasNo"
                                        :error-messages="errors.collect('newChasNo')"
                                        data-vv-name="newChasNo"
                                        :data-vv-as="labels.newChasNo"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
                  <td>{{ row.item.origVehRegNo }}</td>
                  <td>{{ row.item.newVehRegNo }}</td>
                  <td>{{ row.item.origChasNo }}</td>
                  <td>{{ row.item.newChasNo }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [],
      toogleMoreFilter: [],
      headers: [
        { text: 'Transaction Date', value: 'tranDate' },
        { text: 'Original Vehicle Registration No.', value: 'origVehRegNo' },
        { text: 'New Vehicle Registration No.', value: 'newVehRegNo' },
        { text: 'Original Chassis No.', value: 'origChasNo' },
        { text: 'New Chassis No.', value: 'newChasNo' },
        TableConst.tableActionHeader
      ],
      labels: {
        tranDate_from: 'Transaction Date From',
        tranDate_to: 'Transaction Date To',
        origVehRegNo: 'Original Vehicle Registration No.',
        newVehRegNo: 'New Vehicle Registration No.',
        origChasNo: 'Original Chassis No.',
        newChasNo: 'New Chassis No.'
      },
      filters: {
        tranDate_from: undefined,
        tranDate_to: undefined,
        origVehRegNo: undefined,
        newVehRegNo: undefined,
        origChasNo: undefined,
        newChasNo: undefined
      },
      totalItems: 0,
      loading: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getQueryVehicleChassisList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.tranDate_from) {
            currFilters.tranDate_from = formatDisplayDateTime2(removeTime(currFilters.tranDate_from))
          }
          if (currFilters.tranDate_to) {
            currFilters.tranDate_to = formatDisplayDateTime2(removeTime(currFilters.tranDate_to))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  origVehRegNo: datamap.origVehRegNo,
                  origChasNo: datamap.origChasNo,
                  tranDate: datamap.tranDate,
                  revision: datamap.revision,
                  newVehRegNo: datamap.newVehRegNo,
                  newChasNo: datamap.newChasNo,
                  recType: datamap.recType,
                  tranType: datamap.tranType
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.origVehRegNo = undefined
      this.filters.origChasNo = undefined
      this.filters.newVehRegNo = undefined
      this.filters.newChasNo = undefined
      this.filters.tranDate_from = undefined
      this.filters.tranDate_to = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doQuery(obj) {
      this.$router.push({ name: 'queryVehChas', params: { paramMode: 'query', paramObjRes: obj } })
    }
  },
  computed: {
    menu() {
      return this.$store.state.underwriting.dataTransferSettings.menu
    }
  },
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin],
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit')
    }
  }
}
</script>
